import React from 'react';
import { useParams } from 'react-router-dom';
import errorController from 'Components/ErrorScreens';
import RouteLoading from 'Components/RouteLoading';
import useGetRule from 'Hooks/query-hooks/global-rules/useGetRule';
import useGetList from 'Hooks/query-hooks/list/useGetList';
import useGetParameters from 'Hooks/query-hooks/parameters/useGetParameters';
import useGetReduxUsers from 'Hooks/reduxHelperHooks/useGetReduxUsers';
import { useQueryParam } from 'Hooks/useQueryParam';
import UpdateAdvancedRuleLayout from './UpdateAdvancedRuleLayout';

const UpdateAdvancedRulePage = () => {
    const { ruleId } = useParams<{ ruleId: string }>();
    const {
        parsed: { selectedRowId }
    } = useQueryParam();
    const { users } = useGetReduxUsers();

    const listAPI = useGetList(users);
    const parametersAPI = useGetParameters({
        queryParams: { status: JSON.stringify(['active']) }
    });
    const ruleAPI = useGetRule({ ruleId, users });
    const { hasError, errorCmp } = errorController([listAPI.error, ruleAPI.error, parametersAPI.error]);

    React.useEffect(() => {
        // always scroll to the top
        window.scrollTo(0, 0);
    }, []);

    if (
        listAPI.isLoading ||
        listAPI.isFetching ||
        ruleAPI.isLoading ||
        ruleAPI.isFetching ||
        parametersAPI.isLoading ||
        parametersAPI.isFetching
    ) {
        return <RouteLoading />;
    }
    if (hasError) return <>{errorCmp}</>;

    return (
        <UpdateAdvancedRuleLayout
            parameterData={parametersAPI.data}
            listData={listAPI.data!}
            mode='edit'
            ruleData={ruleAPI.data!}
            selectedRowId={selectedRowId?.toString()}
        />
    );
};

export default UpdateAdvancedRulePage;
